<template>
	<form class="purchase" @submit.prevent="submit">
		<ManagingSection>
			<ManagingBox title="거래처">
				<div class="purchase__transaction">
					<input
						v-model="brandName"
						placeholder="브랜드명 또는 담당자명을 입력하세요."
						type="text"
						ref="input"
						@keypress.enter.prevent
						@keyup="typingSearch($event)"
						@keyup.down.prevent="selectByArrow(0, true)"
					/>
					<ul class="purchase__selector" v-if="showSearch">
						<li
							v-for="(brand, idx) in brandList"
							:key="idx"
							ref="selectorList"
						>
							<button
								@click="setBrandName(brand)"
								class="purchase__selector__btn"
								@keydown.up.prevent="
									selectByArrow(idx === 0 ? 'input' : idx - 1)
								"
								@keydown.down.prevent="
									selectByArrow(
										idx + 1 === brandList.length
											? idx
											: idx + 1
									)
								"
							>
								{{ brand.name }}
							</button>
						</li>
					</ul>
				</div>
			</ManagingBox>
			<ManagingBox title="날짜">
				<DateBox v-model="ledgerDate" type="date" />
			</ManagingBox>
			<ManagingBox title="내역">
				<input
					type="text"
					placeholder="내역을 입력하세요"
					v-model="title"
				/>
			</ManagingBox>
			<ManagingBox title="매입/매출">
				<RadioList
					v-model="ledgerType"
					valueName="name"
					:radioList="checkPurchase"
				/>
			</ManagingBox>
			<ManagingBox title="상품 구분">
				<input
					type="text"
					v-model="productDivision"
					placeholder="상품명을 입력하세요"
				/>
			</ManagingBox>
			<ManagingBox title="거래 유형">
				<input
					type="text"
					v-model="dealType"
					placeholder="직거래 or 대행사"
				/>
			</ManagingBox>
			<ManagingBox title="영업 담당자">
				<input
					type="text"
					v-model="managerName"
					placeholder="영업 담당자명을 입력하세요"
				/>
			</ManagingBox>
			<ManagingBox title="단가">
				<input
					ref="unit"
					type="text"
					v-model="unitPrice"
					placeholder="단가를 입력하세요"
					@blur="addComma"
				/>
			</ManagingBox>
			<ManagingBox title="수량" v-if="version === 0">
				<input
					type="text"
					v-model="count"
					placeholder="수량을 입력하세요"
				/>
			</ManagingBox>
			<ManagingBox title="총 금액" v-if="version === 0">
				<input type="text" v-model="sumPrice" />
			</ManagingBox>
			<ManagingBox title="부가세">
				<input
					type="text"
					:value="taxPrice.toLocaleString()"
					disabled
				/>
			</ManagingBox>
			<ManagingBox title="합계">
				<input
					type="text"
					:value="ledgerPrice.toLocaleString()"
					disabled
				/>
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button
				type="submit"
				class="btn-main blue"
				v-text="this.mode === 'register' ? '등록' : '수정'"
			/>
			<button
				type="button"
				class="btn-main"
				v-text="'초기화'"
				@click="init()"
			/>
		</div>
	</form>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '@/components/RadioList';
	import DateBox from '@/components/DateBox';
	import debounce from 'lodash/debounce';

	export default {
		data() {
			return {
				ledgerDate: '',
				checkPurchase: [
					{ id: 1, name: '매입' },
					{ id: 2, name: '매출' },
				],
				ledgerType: 1,
				unitPrice: 0,
				managerName: '',
				title: '',
				productDivision: '',
				dealType: '',
				managerName: '',
				brandName: '',
				brandList: [],
				selectCustomerId: '',
				selectBrandInfo: '',
				showSearch: false,
				titleId: this.$route.params.titleId,
				version: 1,
				count: 0,
				sumPrice: 0,
			};
		},
		props: {
			mode: {
				type: String,
				default: 'register',
			},
		},
		computed: {
			priceNumber() {
				if (this.unitPrice) {
					return parseInt(this.unitPrice.replace(/,/g, ''), 10);
				}
				return 0;
			},
			taxPrice() {
				const tax = this.priceNumber * 0.1;
				return Number(tax);
			},
			ledgerPrice() {
				const sum = this.priceNumber + Number(this.taxPrice);
				return sum;
			},
		},
		components: {
			ManagingSection,
			ManagingBox,
			RadioList,
			DateBox,
		},
		created() {
			this.getData();
		},
		methods: {
			init() {
				this.selectCustomerId = '';
				this.selectBrandInfo = '';
				this.ㄹ = '';
				this.ledgerDate = '';
				this.title = '';
				this.ledgerType = 1;
				this.productDivision = '';
				this.dealType = '';
				this.unitPrice = 0;
				this.count = '';
				this.sumPrice = 0;
				this.managerName = '';
			},
			validation() {
				if (!this.brandName) {
					alert('거래처를 입력해주세요.');
					return false;
				}
				if (!this.ledgerDate) {
					alert('날짜를 입력해주세요');
					return false;
				}
				if (!this.title) {
					alert('내역을 입력해주세요');
					return false;
				}
				if (!this.productDivision) {
					alert('상품구분을 입력해주세요');
					return false;
				}
				if (!this.dealType) {
					alert('거래유형을 입력해주세요');
					return false;
				}
				if (!this.managerName) {
					alert('담당자명을 입력해주세요');
					return false;
				}
				if (!this.unitPrice || this.unitPrice === 0) {
					alert('단가를 입력해주세요');
					return false;
				}
				return true;
			},
			async getData() {
				if (this.mode === 'modify' && this.titleId) {
					try {
						const { data } = await this.$axiosAdmin2.get(
							`/api/ledgerPurchaseV2/${this.titleId}`
						);
						this.selectCustomerId = data.customerManageV2Id;
						this.selectBrandInfo = data.customerManageV2MetaInfoId;
						this.brandName = `${data.customerComName} (${data.brandTitle ? `${data.brandTitle} - ` : ''}${data.customerManagerName ?? '-'})`;
						this.ledgerDate = data.ledgerDate.replace(
							/(\d{4})(\d{2})(\d{2})/,
							'$1-$2-$3'
						);
						this.ledgerType = Number(data.ledgerType);
						this.title = data.title;
						this.productDivision = data.productDivision;
						this.dealType = data.dealType;
						this.managerName = data.managerName;
						this.unitPrice = Number(
							data.unitPrice
						).toLocaleString();
						this.version = data.version;
						this.count = data.count;
						this.sumPrice = data.sumPrice;
					} catch (err) {
						console.error(err);
					}
				}
			},
			typingSearch(e) {
				const arrowKeyCode = [37, 38, 39, 40];
				if (arrowKeyCode.includes(e.keyCode)) {
					return;
				} else {
					this.searchBrand(e);
				}
			},
			selectByArrow(idx, fromInput) {
				const selectorList = this.$refs.selectorList;
				if (fromInput) {
					this.$refs.input.focus();
					setTimeout(() => {
						selectorList[idx]
							.querySelector('.purchase__selector__btn')
							.focus();
					});
					return;
				}
				if (!selectorList || idx === 'input') {
					this.$refs.input.focus();
					return;
				}
				selectorList[idx]
					.querySelector('.purchase__selector__btn')
					.focus();
			},
			searchBrand: debounce(async function (event) {
				if (event.target.value.trim().length > 0) {
					const keyword = event.target.value;
					try {
						const { data } = await this.$axiosAdmin2.get(
							`api/customerManageV2/search?query=${keyword}`
						);
						data.forEach(element => {
							element.name = `${element.companyName} (${element.brandTitle ? `${element.brandTitle} - ` : ''}${element.managerName})`;
						});
						this.brandList = [...data];
						this.showSearch = this.brandList.length > 0;
					} catch (err) {
						console.error(err);
						alert(
							'검색에 실패 발생하였습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
						);
					}
				} else {
					this.showSearch = false;
				}
			}, 500),
			setBrandName(brand) {
				this.brandName = brand.name;
				this.selectCustomerId = brand.customerManageV2Id;
				this.selectBrandInfo = brand.customerManageV2MetaInfoId;
				this.showSearch = false;
			},
			async submit() {
				if (!this.validation()) return;
				try {
					const params = {
						customerManageV2Id: this.selectCustomerId,
						customerManageV2MetaInfoId: this.selectBrandInfo,
						ledgerDate: this.ledgerDate.replace(/-/g, ''),
						title: this.title,
						ledgerType: this.ledgerType,
						productDivision: this.productDivision,
						dealType: this.dealType,
						managerName: this.managerName,
						unitPrice: this.priceNumber,
						taxPrice: this.taxPrice,
						ledgerPrice: this.ledgerPrice,
					};
					if (this.mode === 'register') {
						await this.$axiosAdmin2.post(
							`/api/ledgerPurchaseV2`,
							params
						);
					} else {
						params.id = Number(this.titleId);
						params.count = this.count;
						params.sumPrice = this.sumPrice;
						await this.$axiosAdmin2.put(
							`/api/ledgerPurchaseV2`,
							params
						);
					}
					alert(
						`${this.mode === 'register' ? '등록' : '수정'}하였습니다.`
					);
					this.$router.go(-1);
				} catch (err) {
					console.error(err);
				}
			},
			addComma() {
				this.unitPrice = this.priceNumber.toLocaleString();
			},
		},
	};
</script>
<style lang="scss" scoped>
	.purchase {
		&__transaction {
			position: relative;
			display: flex;
			align-items: center;
			width: 500px;
			gap: 10px;
		}

		&__selector {
			position: absolute;
			overflow: auto;
			z-index: 999;
			top: 36px;
			width: 500px;
			min-height: 100px;
			max-height: 300px;
			background-color: #fff;
			border: solid 1px #dfe6ee;
			border-radius: 5px;
			padding: 1em 0;
			font-size: 0.875rem;
		}

		&__selector__btn {
			display: block;
			width: 100%;
			text-align: left;
			padding: 0.5em 1em;
			cursor: pointer;

			&:focus,
			&:hover {
				background: #f4f7fa;
			}
		}
	}
</style>
